export var ExportStatus = /*#__PURE__*/ function(ExportStatus) {
    ExportStatus["Processing"] = "PROCESSING";
    ExportStatus["Failed"] = "FAILED";
    ExportStatus["Completed"] = "COMPLETED";
    ExportStatus["EXPIRED"] = "EXPIRED";
    return ExportStatus;
}({});
export var ExportType = /*#__PURE__*/ function(ExportType) {
    ExportType["ResourceRequest"] = "RESOURCE_REQUEST";
    ExportType["TimeTrackingReport"] = "TIME_TRACKING_REPORT";
    ExportType["ProjectList"] = "PROJECT_LIST";
    ExportType["ProjectTimeline"] = "PROJECT_TIMELINE";
    ExportType["ResourceAllocationReport"] = "RESOURCE_ALLOCATION_REPORT";
    ExportType["ResourceAllocation"] = "RESOURCE_ALLOCATION";
    ExportType["UtilizationReport"] = "UTILIZATION_REPORT";
    ExportType["TimesheetSubmissionReport"] = "TIMESHEET_SUBMISSION_REPORT";
    ExportType["UserTimeAnalytics"] = "USER_TIME_ANALYTICS";
    ExportType["ProjectTimeAnalytics"] = "PROJECT_TIME_ANALYTICS";
    ExportType["CategoryTimeAnalytics"] = "CATEGORY_TIME_ANALYTICS";
    ExportType["CpAccountTimeTrackingReport"] = "CP_ACCOUNT_TIME_TRACKING_REPORT";
    ExportType["CpProjectTimeTrackingReport"] = "CP_PROJECT_TIME_TRACKING_REPORT";
    ExportType["CpAccountTimeEntries"] = "CP_ACCOUNT_TIME_ENTRIES";
    ExportType["CpProjectTimeEntries"] = "CP_PROJECT_TIME_ENTRIES";
    ExportType["AccountsList"] = "COMPANY_LIST";
    ExportType["Expense"] = "EXPENSE";
    ExportType["KeyEventUnderlyingProjects"] = "PROJECT_IQ_REPORT";
    ExportType["RevenueEntry"] = "REVENUE_ENTRY";
    ExportType["RevenueOverview"] = "REVENUE_OVERVIEW";
    return ExportType;
}({});
